import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=76a55e17&"
import script from "./ButtonClose.vue?vue&type=script&lang=js&"
export * from "./ButtonClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../visual/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports